<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TemplateModal from "@/components/modals/du-service-template.vue";
import SubscriberModal from "@/components/modals/subscriber.vue";
import FeeModal from "@/components/modals/fee-template-modal.vue";
import MapModal from '@/components/modals/map-modal.vue'
import {cloneDeep, groupBy} from "lodash";
import Swal from "sweetalert2";
import ServiceList from "@/components/widgets/service-list.vue";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
    page: {
        title: "Delivery Unit Service",
    },
    components: {
        Layout,
        PageHeader,
        TemplateModal,
        SubscriberModal,
        FeeModal,
        MapModal,
        ServiceList,
        PrintOptions,
    },
    data() {
        return {
            title: "Delivery Unit Services",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Delivery Unit Services",
                    active: true,
                },
            ],
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            filter: null,
            loading: false,
            services: [],
            filteredFees: [],
            fees: [],
            locations: [],
            templates: [],
            selectedService: null,
            selectedPlaceholder: null,
            modalTitle: null,
        };
    },
    created() {
        this.changeDU(this.$store.state.data.selectedDU.id);
        this.changeCampus(this.$store.state.data.selectedCampus.id);
    },
    methods: {
        async changeCampus(id) {
            this.getFees(id);
        },
        async changeDU(duId) {
            this.loading = true;
            await this.getServices(duId);
            this.loading = false;
        },
        async getFees(id){
            await this.$store
                .dispatch("fee/getFeesByCampus", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.selected = false;
                    })
                    this.fees = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
                });
        },
        async getServices(id){
            await this.$store
                .dispatch("deliveryunitservices/getDeliveryUnitServicesByDU", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }

                    res.data.map(item => {
                        item.filterKey = `${item.serviceName}`;
                        item.rotateChevy = false;
                        item.templates = []
                        item.subscribers = [];
                        item.maps = [];
                        item.unpaid = [];
                        item.unpaidSummary = [];
                        item.unpaidLoading = false;
                        item.subscriberLoading = false;
                        item.mapLoading = false;
                        item.loading = false;
                        item.menuSelection = 0;
                    })
                    this.services = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
                });
        },
        async showTemplates(item){
            item.rotateChevy = !item.rotateChevy;
            if(item.rotateChevy && !item.templates.length){
                item.loading = true;
                await this.getDUTemplates(item)
                item.loading = false;
            }
        },
        async getDUTemplates(item){
            await this.$store
                .dispatch("duservicefeetemplate/getDUServiceFeeTemplatesByService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.minimumAmount = item.minimumAmount ? item.minimumAmount.toString() : '';
                        item.minimumUnit = item.minimumUnit ? item.minimumUnit.toString() : '';
                        item.deliveryUnitServiceFees.map(x => {
                            x.editMode = false;
                            x.selected = false;
                            x.amount = x.amount ? x.amount.toString() : '';
                            x.percentage = x.percentage ? x.percentage.toString() : '';
                        });
                    })
                    item.templates = res.data;
                    this.templates = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch delivery unit service templates.", "error");
                });
        },
        addTemplate(item){
            this.selectedService = item;
            this.modalTitle = "Add New Fee Template";
            this.$refs.templateModal.resetForm();
            this.$refs.templateModal.updateData({
                id: 0,
                templateName: null,
                templateDescription: null,
            });
            this.$bvModal.show('du-service-template-modal');
        },
        onSubmitTemplate(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if (modalData.id > 0) {
                this.$store
                    .dispatch("duservicefeetemplate/updateDUServiceFeeTemplate", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.templates.findIndex((x) => x.id == modalData.id);
                        this.selectedService.templates.splice(index, 1, modalData)
                        this.$refs.services.targetTemplate(this.selectedService.id, modalData);
                        this.$bvModal.hide('du-service-template-modal');
                        this.showToast("Delivery unit service updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update delivery unit service.", "error");
                    });
            }else{
                this.$store
                    .dispatch("duservicefeetemplate/createDUServiceFeeTemplate", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.deliveryUnitServiceFees = [];
                        res.data.loadingTemplate =  false;
                        this.selectedService.templates.push(res.data);
                        this.$bvModal.hide('du-service-template-modal');
                        this.showToast("Delivery unit service created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot create delivery unit service.", "error");
                    });
            }
        },
        editTemplate({row, parent}){
            this.selectedService = parent;
            this.modalTitle = "Update Fee Template";
            let data = cloneDeep(row);
            data.minimumUnit = row.minimumUnit ? row.minimumUnit.toString() : '';
            data.minimumAmount = row.minimumAmount ? row.minimumAmount.toString() : '';
            data.dueInDays = row.dueInDays ? row.dueInDays.toString() : '';
            this.$refs.templateModal.updateData(data);
            this.$bvModal.show('du-service-template-modal');
        },
        deleteTemplate({row, parent}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("duservicefeetemplate/removeDUServiceFeeTemplate", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.templates.findIndex((x) => x.id == row.id);
                            parent.templates.splice(index, 1);
                            this.$refs.services.targetTemplate(parent.id, {id: 0});
                            this.showToast("Template deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete template.", "error");
                        });
                }
            });
        },
        addFees({duServices, service}){
            this.filteredFees = [];
            this.filteredFees = this.fees.filter((item) => {
                return !duServices.some((template) => template.feeId == item.id);
            });
            this.selectedService = service;
            this.modalTitle = 'Add Fees';
            this.$bvModal.show('fee-template-modal');
        },
        async addSubscriber(service, data){
            this.selectedService = service;
            this.$refs.subscriberModal.resetForm();
            this.$refs.subscriberModal.getAccNo();
            if(data){
                this.$refs.subscriberModal.addFromMap(data);
            }
            this.modalTitle = 'Add Subscriber';
            this.$bvModal.show('subscriber-modal');
            if(!service.maps.length){
                await this.getMaps(service);
            }
            if(!service.templates.length){
                await this.getDUTemplates(service);
            }
        },
        async updateSubscriber({service, data}){
            this.selectedService = service;
            this.modalTitle = 'Edit Subscriber';
            this.$refs.subscriberModal.updateData(data);
            this.$bvModal.show('subscriber-modal');
            if(!service.maps.length){
                await this.getMaps(service);
            }
        },
        removeSubscriber({service, data}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("subscriber/RemoveSubscriber", data.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = service.subscribers.findIndex((x) => x.id == data.id);
                            service.subscribers.splice(index, 1);
                            this.showToast("Subscriber deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete subscriber.", "error");
                        });
                }
            });
        },
        subscriberReading(service, data){
            this.selectedService = service;
            this.$refs.subscriberReadingModal.getData(data);
            this.$bvModal.show('subscriber-reading-modal');
        },
        addSelectedFees(selFees){
            this.$bvModal.hide('fee-template-modal');
            let data = []
            this.fees.map(item => item.selected = false);
            selFees.map(item => {
                data.push({
                    id: 0,
                    feeId: item.id,
                    feeName: item.name,
                    amount: item.defaultAmount.toString(),
                    percentage: '',
                    accountId: item.account.id,
                    account: item.account.accountName,
                    editMode: false,
                    selected: false,
                })
            })
            this.$refs.services.addFeesToTemplate(this.selectedService.id, data);
        },
        onSubmitSubscriber(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if(modalData.id > 0){
                 this.$store
                    .dispatch("subscriber/UpdateSubscriber", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.subscribers.findIndex((x) => x.id == modalData.id);
                        this.selectedService.subscribers.splice(index, 1, modalData);
                        this.$bvModal.hide('subscriber-modal');
                        this.showToast("Subscriber updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update subscriber.", "error");
                    });
            }else{
                this.$store
                    .dispatch("subscriber/AddSubscriber", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.viewReading = false;
                        this.selectedService.subscribers.push(res.data);
                        this.$bvModal.hide('subscriber-modal');
                        this.showToast("Subscriber created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update subscriber.", "error");
                    });
            }
        },
        async getSubscribers(item){
            item.subscribers = [];
            await this.$store
                .dispatch("subscriber/GetSubscriberByDUService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.viewReading = false; 
                        item.subscriberName = item.client.trim();
                    });
                    item.subscribers = res.data.sort((a, b) => a.client.localeCompare(b.client));
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch subscribers.", "error");
                });
        },
        async getMaps(item){
            await this.$store
                .dispatch("deliveryunitservicemap/getDeliveryUnitByService", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        let coordinates = JSON.parse(item.coordinates);
                        item.right = coordinates.right;
                        item.bottom = coordinates.bottom;
                        item.top = coordinates.top;
                        item.left = coordinates.left;
                    })
                    item.maps = res.data;
                    this.locations = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch maps.", "error");
                });
        },
        onSubmitMap(modalData){
            modalData.deliveryUnitServiceId = this.selectedService.id;
            if(modalData.id > 0){
                this.$store
                    .dispatch("deliveryunitservicemap/updateDeliveryUnitServiceMap", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedService.maps.findIndex((x) => x.id == modalData.id);
                        this.selectedService.maps.splice(index, 1, modalData);
                        this.$bvModal.hide('map-modal');
                        this.$refs.services.calculateGridSize(this.selectedService.id);
                        this.showToast("Map updated successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot update map.", "error");
                    });
            }else{
                modalData.parentDeliveryUnitServiceMapId = 0;
                let coor = {top: 0, left: 0, right: null, bottom: null}
                if(!this.selectedPlaceholder){
                    modalData.coordinates = JSON.stringify(coor);
                }else{
                    if(this.selectedPlaceholder.direction == 'right'){
                        coor = {top: this.selectedPlaceholder.sourceBox.top, left: this.selectedPlaceholder.sourceBox.id, right: null, bottom: null};
                        modalData.coordinates = JSON.stringify(coor);
                    }else if(this.selectedPlaceholder.direction == 'bottom'){
                        coor = {top: this.selectedPlaceholder.sourceBox.id, left: this.selectedPlaceholder.sourceBox.left, right: null, bottom: null};
                        modalData.coordinates = JSON.stringify(coor);
                    }else{
                        modalData.coordinates = JSON.stringify(coor)
                    }
                }
                this.$store
                    .dispatch("deliveryunitservicemap/createDeliveryUnitServiceMap", modalData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        modalData.id = res.data.id;
                        modalData.left = coor.left;
                        modalData.top = coor.top;
                        modalData.right = coor.right;
                        modalData.bottom = coor.bottom;
                        this.selectedService.maps.push(modalData);
                        this.$bvModal.hide('map-modal');
                        this.$refs.services.calculateGridSize(this.selectedService.id);
                        this.showToast("Map created successfully.", "success");
                    })
                    .catch((error) => {
                        this.showToast("Something went wrong! Cannot add map.", "error");
                    });
            }
        },
        async fetchUnpaid(item, dates){
            item.unpaidLoading = true;
            item.unpaid = [];
            if(!dates){
                await this.getUnpaidSummary(item)
            }else{
                await this.getUnpaid(item, dates);
            }
            item.unpaidLoading = false;
        },
        async getUnpaid(item, dates){
            await this.$store
                .dispatch("subscribermeterreading/GetUnpaidSubscriberMeterReadingByDUService", {id: item.id, ...dates, removeLoading: true})
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => item.selected = false);
                    item.unpaid = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch unpaid.", "error");
                });
        },
        async getUnpaidSummary(item){
            await this.$store
                .dispatch("subscribermeterreading/GetUnpaidSubscriberMeterReadingSummary", item.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.viewReading = false;
                        item.id = item.subscriberId;
                    });
                    item.unpaid = res.data;
                })
                .catch((error) => {
                    this.showToast("Something went wrong! Cannot fetch unpaid.", "error");
                });
        },
        async selectMenu({item, index}){
            item.menuSelection = index;
            if(index == 1){
                item.subscriberLoading = true;
                await this.getSubscribers(item);
                item.subscriberLoading = false;
            }else if (index == 2){
                item.mapLoading = true;
                await this.getMaps(item);
                item.mapLoading = false;
            }else if (index == 3){
                if(!item.unpaidSummary.length){
                    this.fetchUnpaid(item, null);
                }
            }
        },
        addServiceMap({placeholder, parent}){
            this.selectedService = parent;
            this.selectedPlaceholder = placeholder;
            this.$refs.mapModal.resetForm();
            this.modalTitle = 'Add Service Map';
            this.$bvModal.show('map-modal');
        },
        editServiceMap({item, parent}){
            this.selectedService = parent;
            this.modalTitle = 'Edit Service Map';
            this.$refs.mapModal.updateData(item);
            this.$bvModal.show('map-modal');
        },
        deleteServiceMap({item, parent}){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("deliveryunitservicemap/deleteDeliveryUnitServiceMap", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.maps.findIndex((x) => x.id == item.id);
                            parent.maps.splice(index, 1);
                            this.$refs.services.calculateGridSize(parent.id);
                            this.showToast("Map deleted successfully.", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong! Cannot delete map.", "error");
                        });
                }
            });
        },
        generateReadings(selected){
            let ids = selected.map(item => item.id);
            this.$refs.printOpt.putOptions({
                apiUrl: 'api/Report/DeliveryUnitService/Multiple/Water/Bill', 
                routeVariables: [],
                body: ids 
            })
            this.$bvModal.show('print-options-modal')
        }
    },
}
</script>
<template>
  <Layout @changeCampus="changeCampus($event.id)" @changeDU="changeDU($event.id)">
    <PageHeader :title="title" :items="items" />
    <div id="tickets-table_filter" class="dataTables_filter me-1 d-flex justify-content-between">
        <label class="d-inline-flex align-items-center mb-0 gap-1">
            <b-form-input
                autocomplete="off"
                v-model="filter"
                type="search"
                placeholder="Search service..."
                class="form-control"
                style="width: 250px;"
            ></b-form-input>
            <b-form-select
                class="form-select"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                style="width: 90px;"
            ></b-form-select>
        </label>
    </div>
    <div class="mt-3">
        <template v-if="loading">
            <template v-for="n in 3" >
                <div :key="n" class="mb-2">
                    <div class="d-flex align-items-center mb-1" >
                        <b-skeleton
                            width="10px"
                            height="10px"
                            class="me-2"
                        ></b-skeleton>
                        <b-skeleton
                            width="250px"
                            height="25px"
                        ></b-skeleton>
                    </div>
                    <div v-for="a in 3" :key="a" class="mb-1">
                        <b-skeleton
                            width="98%"
                            height="50px"
                            class="ms-5"
                        ></b-skeleton>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-if="!services.length">
                <div class="text-center py-5 my-5">
                    No Data Found.
                </div>
            </template>
            <template v-else>
                <ServiceList
                    ref="services"
                    :list="services"
                    :filter="filter"
                    :loading="loading"
                    @show-templates="showTemplates"
                    @select-menu="selectMenu"
                    @add-template="addTemplate"
                    @edit-template="editTemplate"
                    @delete-template="deleteTemplate"
                    @add-fees="addFees"
                    @add-subscriber="addSubscriber"
                    @add-service-map="addServiceMap"
                    @edit-service-map="editServiceMap"
                    @delete-service-map="deleteServiceMap"
                    @remove-subscriber="removeSubscriber"
                    @update-subscriber="updateSubscriber"
                    @get-unpaid="fetchUnpaid($event.data, $event.dates)"
                    @get-unpaid-summary="fetchUnpaid($event, null)"
                    @generate-readings="generateReadings"
                />
            </template>
        </template>
    </div>
    <TemplateModal
        ref="templateModal"
        :modalTitle="modalTitle"
        @submit="onSubmitTemplate"
    />
    <FeeModal 
        ref="feeModal"
        :fees="filteredFees"
        :modalTitle="modalTitle"
        @selected-fees="addSelectedFees"
    />
    <SubscriberModal 
        ref="subscriberModal"
        :locations="locations"
        :templates="templates"
        :modalTitle="modalTitle"
        @submit="onSubmitSubscriber"
    />
    <MapModal 
        ref="mapModal"
        :modalTitle="modalTitle"
        @submit="onSubmitMap"
    />
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>